module.exports = __webpack_public_path__ + "static/icon-logo-bde9b980b29324aae2688ef366fcd1a5.png";